import range from 'lodash-es/range';
export const flattenOffers = (offers) => {
    if (!offers) {
        return [];
    }
    return offers.reduce((accumulator, currentOffer) => {
        return [
            ...accumulator,
            ...range(currentOffer.quantity).map(() => ({ ...currentOffer, quantity: 1 })),
        ];
    }, []);
};
